import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=0da0d199&lang=scss&scoped=true"

import exportComponent from "/Users/clopez/Documents/Repositorios/Muevetec/landing-muevetec-base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da0d199"]])

export default __exports__